export default (data) => ({
  id: data.id,
  firstName: data.firstName,
  lastName: data.lastName,
  email: data.email,
})
